(function() {
  // Only run on CreaseLine product page
  if (!window.location.pathname.includes('/products/creaseline')) return;
  
  function fixPdfLinks() {
    var links = document.querySelectorAll('.pitch-diagram-pdf-link');
    
    if (links.length === 0) {
      // No links exist - inject one
      var inner = document.querySelector('.pitch-diagram-section__inner');
      var trigger = document.getElementById('diagramTrigger');
      if (!inner || !trigger) return false;
      
      var wrapper = document.createElement('p');
      wrapper.className = 'pitch-diagram-pdf-wrapper';
      
      var pdfLink = document.createElement('a');
      var img = inner.querySelector('img');
      if (img && img.src) {
        pdfLink.href = img.src.replace('creaseline-diagram-v2.svg', 'creaseline-pitch-diagram.pdf').split('?')[0];
      } else {
        pdfLink.href = '//shop.ovacricket.com/cdn/shop/t/5/assets/creaseline-pitch-diagram.pdf';
      }
      pdfLink.target = '_blank';
      pdfLink.rel = 'noopener';
      pdfLink.className = 'pitch-diagram-pdf-link';
      pdfLink.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg> Download PDF';
      pdfLink.addEventListener('click', function(e) { e.stopPropagation(); });
      
      wrapper.appendChild(pdfLink);
      if (trigger.nextSibling) {
        trigger.parentNode.insertBefore(wrapper, trigger.nextSibling);
      } else {
        trigger.parentNode.appendChild(wrapper);
      }
    } else if (links.length > 1) {
      // Multiple links exist - remove duplicates, keep only the first one
      for (var i = 1; i < links.length; i++) {
        var parent = links[i].parentNode;
        if (parent && parent.classList && parent.classList.contains('pitch-diagram-pdf-wrapper')) {
          parent.remove();
        } else {
          links[i].remove();
        }
      }
    }
    return true;
  }
  
  // Run after DOM is ready and inline scripts have executed
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(fixPdfLinks, 100);
    });
  } else {
    setTimeout(fixPdfLinks, 100);
  }
})();
